import { useAuth } from '@domain/auth/auth.hook';
import React, { useState } from 'react';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import { MetricSelectionProps } from '@screens/players/player.actions/metrics/metric.selection.props';
import { MetricsComboBoxStyled, MetricsSelect } from '@screens/players/player.actions/metrics/metrics.styles';

interface MetricsData {
  id: number;
  metric: string;
  active: boolean;
}

const MetricsComboBox = ({ onChange, comboLabel }: MetricSelectionProps) => {
  const { authorizedServices } = useAuth();
  function selectStats(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    e.preventDefault();
    onChange(e.target.value as string);
  }

  const comboboxLabel = comboLabel;

  async function getMetrics(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<MetricsData[]>('/admin/metrics/list', { cancelToken });
  }
  const { responseData, loading, validationErrors } = usePagedData(null, getMetrics, {});

  const metricsData = responseData ?? [];

  const [metrics, setMetrics] = useState('');

  function handleMetricsChange(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    setMetrics(e.target.value as string);
    selectStats(e);
  }

  return (
    <>
      <MetricsComboBoxStyled>
        <FormControl>
          <InputLabel id='metricCombo'>{comboboxLabel}</InputLabel>
          <MetricsSelect
            native
            labelId='metricCombo'
            id='metricCombo'
            inputProps={{ name: 'metricCombo' }}
            disabled={loading}
            onChange={handleMetricsChange}
            value={metrics}
          >
            <option />
            {metricsData.map((v) => (
              <option key={v.metric} value={v.metric}>
                {v.metric}
              </option>
            ))}
          </MetricsSelect>
          <FormHelperText error>{validationErrors}</FormHelperText>
        </FormControl>
      </MetricsComboBoxStyled>
    </>
  );
};

export default MetricsComboBox;
